  document.addEventListener('DOMContentLoaded', () => {

    const items = document.querySelectorAll('.js-acc');

    const setHeight = (item) => {
      const answer = item.querySelector('.js-accContents');
      answer.style.height = answer.scrollHeight + 'px';
    };

    items.forEach(item => {
      const button = item.querySelector('.js-accLabel');
      const answer = item.querySelector('.js-accContents');

      // 初期状態（is-openがついているもの）
      if (item.classList.contains('is-open')) {
        setHeight(item);
      }

      button.addEventListener('click', () => {

        const isOpen = item.classList.contains('is-open');

        if (isOpen) {
          // 閉じる
          item.classList.remove('is-open');
          answer.style.height = 0;
        } else {
          // 開く
          item.classList.add('is-open');
          setHeight(item);
        }

      });
    });

    // -----------------------------
    // リサイズ時の再計算（0.5秒デバウンス）
    // -----------------------------
    let resizeTimer = null;

    window.addEventListener('resize', () => {

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {

        document.querySelectorAll('.js-acc.is-open')
          .forEach(item => {
            setHeight(item);
          });

      }, 500); // 0.5秒後に再計算

    });

  });

